import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { RevealLines, FadeUp } from "@/components/Reveal";
import { ProductCard } from "@/components/ProductCard";
import { ProductModal } from "@/components/ProductModal";

const SPAN = { 1: "lg:col-span-1", 2: "lg:col-span-2", 3: "lg:col-span-3", 4: "lg:col-span-4" };

const noteSpan = (n) => {
  if (n === 1) return "lg:col-span-2 lg:row-span-2";
  if (n === 2) return "lg:col-span-4";
  const r = (n + 3) % 4;
  return SPAN[r === 0 ? 4 : 4 - r];
};

const NoteCard = ({ n }) => (
  <FadeUp className={`${noteSpan(n)} rounded-[22px] border border-purple-400/20 bg-[#231136] p-8 md:p-10 flex flex-col justify-between min-h-[300px]`}>
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-amber-200">A note from Liza</span>
    <p className={`font-display italic leading-tight text-purple-50 mt-6 ${n > 2 && (n + 3) % 4 === 3 ? "text-2xl" : "text-3xl md:text-4xl"}`}>
      “Each bracelet is strung slowly, bead by bead, while I think about the person who will wear it.”
    </p>
    <span className="mt-6 text-sm text-purple-200">— Liza Zhen</span>
  </FadeUp>
);

export const Shop = () => {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    http.get("/products")
      .then((r) => setProducts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setProducts([]));
  }, []);

  return (
    <section id="shop" className="relative py-24 md:py-36" data-testid="shop-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-purple-300 mb-6">II — The Bracelets</p>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
              <RevealLines inView lines={[<>Strung for</>, <em className="text-purple-300">your secret.</em>]} />
            </h2>
          </div>
          <FadeUp className="max-w-sm text-purple-100/85 leading-relaxed">
            Lavender Hollow bracelets, handmade by Liza with one intention each. Tap a stone to learn its story, or add it straight to your cart.
          </FadeUp>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:auto-rows-[320px] gap-4 md:gap-5">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} big={i === 0 || products.length <= 2} onOpen={setActive}
              className={products.length <= 2 || i === 0 ? "lg:col-span-2 lg:row-span-2" : ""} />
          ))}
          {products.length > 0 && <NoteCard n={products.length} />}
        </div>
      </div>
      <ProductModal product={active} onClose={() => setActive(null)} />
    </section>
  );
};
